export const SLIDE_WIDTH = 214; // Ширина слайда в пикселях
export const SLIDE_IMAGE_HEIGHT = 294; // Высота изображения слайда в пикселях
export const SLIDE_GAP = 24; // Расстояние между слайдами в пикселях
